import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=0a8e487e&scoped=true"
import script from "./BackToTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackToTop.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=0a8e487e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8e487e",
  null
  
)

export default component.exports